import { connect } from 'react-redux';
import StatisticsByCountryMetrics from './StatisticsByCountryMetrics.js';
import actions from './StatisticsByCountryMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsByCountryMetrics.selectors';
import ReportByCountryComponent from '../../../../utils/ReportByCountryComponent/ReportByCountryComponent';

const reportUtils = ReportByCountryComponent.utils;

const StatisticsByCountryMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsByCountryMetrics);

export default StatisticsByCountryMetricsComponent;
